<div
  class="crowdctrl-form-textarea-field-wrap"
  [class.crowdctrl-form-textarea-field-wrap--invalid]="invalid"
>
  @if (formControl) {
    <ion-textarea
      class="textarea-fill-outline"
      [formControl]="formControl"
      [label]="effectiveLabel"
      fill="outline"
      [placeholder]="effectivePlaceholder"
      [attr.required]="effectiveRequired"
      [attr.aria-label]="effectiveAriaLabel ?? null"
      [rows]="fillAvailableHeight ? (rows ?? undefined) : (rows ?? 4)"
      [maxlength]="maxlength ?? null"
      [minlength]="minlength ?? null"
      [inputmode]="inputmode"
      [autocapitalize]="autocapitalize"
      [spellcheck]="spellcheck"
      (ionInput)="ionInput.emit($event)"
      (ionChange)="ionChange.emit($event)"
      (ionBlur)="ionBlur.emit($event)"
      (ionFocus)="ionFocus.emit($event)"
    ></ion-textarea>
  } @else {
    <ion-textarea
      class="textarea-fill-outline"
      [label]="effectiveLabel"
      fill="outline"
      [placeholder]="effectivePlaceholder"
      [attr.required]="effectiveRequired"
      [attr.aria-label]="effectiveAriaLabel ?? null"
      [disabled]="disabled"
      [rows]="fillAvailableHeight ? (rows ?? undefined) : (rows ?? 4)"
      [maxlength]="maxlength ?? null"
      [minlength]="minlength ?? null"
      [inputmode]="inputmode"
      [autocapitalize]="autocapitalize"
      [spellcheck]="spellcheck"
      (ionInput)="ionInput.emit($event)"
      (ionChange)="ionChange.emit($event)"
      (ionBlur)="ionBlur.emit($event)"
      (ionFocus)="ionFocus.emit($event)"
    ></ion-textarea>
  }
  @if (hint) {
    <p class="crowdctrl-form-control-hint">{{ hint }}</p>
  }
</div>
